import React, { useEffect, useState } from "react";
import Table from "./Table";
import AddHotel from "./AddPolicy";
import "./style.css";
import MessageProvider from "./Context";
import REACT_APP from "../../environment";
import axios from "axios";

const Hotel = () => {
    const [isWaiting, setIsWaiting] = useState(false);
    const [policyTypes, setPolicyTypes] = useState([]);

    const getPolicyType = async () => {
        await axios
            .get(`${REACT_APP.URL}/api/hdp/tts/adm/hotel/policy/type`, {
                headers: { Authorization: sessionStorage.getItem("token"), "client-id": REACT_APP.CLIENTID, "client-secret": REACT_APP.SECRET },
            })
            .then((res) => setPolicyTypes(res.data.data))
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        getPolicyType();
    }, []);

    return (
        <div className="container">
            {isWaiting && <div className="ca-overlay"></div>}
            <MessageProvider>
                <Table setIsWaiting={setIsWaiting} policyTypes={policyTypes} />
                <AddHotel policyTypes={policyTypes} />
            </MessageProvider>
        </div>
    );
};

export default Hotel;
